package com.essntl.uikit.components.iconbutton.secondary

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.button.secondary.getSecondaryButtonColors
import com.essntl.uikit.components.iconbutton.EsIconButton
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsLargeSecondaryIconButton(
    onClick: () -> Unit,
    iconRes: String,
    enabled: Boolean = true,
    loading: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsIconButton(
        onClick = onClick,
        size = EsButtonSize.Large,
        colors = getSecondaryButtonColors(essntlColorScheme),
        iconRes = iconRes,
        enabled = enabled,
        loading = loading,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}